import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/duhokim/Desktop/DIX/kingdom/dev/kosta-admin/src/layout/default.vue").then(m => m.default || m))
}